import type { Messages } from '@/features/locale/messages'

import { CDONT } from './tokens/infinite-creative'

export type TokenDetailTab = 'overview' | 'liquidity' | 'contract' | 'chart'

export function buildTokenDetailTabLabels(t: Messages): Record<TokenDetailTab, string> {
  return {
    overview: t.common.overview,
    liquidity: t.common.liquidity,
    contract: t.common.contract,
    chart: t.common.chart,
  }
}

export function parseTokenDetailTab(value: string | null | undefined): TokenDetailTab {
  if (value === 'liquidity' || value === 'contract' || value === 'chart') return value
  return 'overview'
}

export function buildTokenDetailPath(address: string, tab?: TokenDetailTab): string {
  const base = `/token/${address}`
  if (!tab || tab === 'overview') return base
  return `${base}?tab=${tab}`
}

/** Dirección por defecto al entrar sin :address (Dont Panic en Creative). */
export const DEFAULT_TOKEN_DETAIL_ADDRESS = CDONT.address
